// @react/hooks/useFormForm.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { formFormStore } from '@core/stores';

/**
 * React hook for Form operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useFormForm } from '@react/hooks';
 *
 * const FormList = observer(() => {
 *   const store = useFormForm();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useFormForm() {
  return formFormStore;
}
